@if (formConfig() && _isOpen()) {
    <!-- #region description -->
    @if (formConfig().description) {
        <div class="grid-container">
            <div
                class="g-12"
                [innerHTML]="formConfig().description"
                [ngClass]="{ 'p-24:b md:p-32:b lg:p-48:b': !additionalComponents() }"
            ></div>
        </div>
    }
    <!-- #endregion -->

    <!-- #region additional components -->
    @for (additionalComponent of additionalComponents(); track $index) {
        <ng-container *ngComponentOutlet="additionalComponent" />
    }

    <!-- #endregion -->

    <form
        [formGroup]="form"
        (submit)="submit()"
    >
        <!-- #region dynamic form -->
        @for (objectFormGroup of formGroups(); track objectFormGroup; let i = $index) {
            <app-form-toggle
                [multiplesAllowed]="formConfig().max > 1"
                [title]="formConfig().objectDescriptionSingular"
                [descriptionKey]="formConfig().objectInfoControl"
                [formGroup]="objectFormGroup"
                [objectIndex]="i"
                [objectsTotal]="form.controls.objects.length"
                (remove)="removeObject($event)"
            >
                <app-insured-object-dynamic-form
                    [formGroup]="objectFormGroup"
                    [formControlsConfig]="formConfig().controls"
                    [insuranceTypeId]="insuranceType().id"
                ></app-insured-object-dynamic-form>
            </app-form-toggle>
        }
        <!-- #endregion -->

        <!-- #region note -->
        @if (formConfig().note) {
            <div class="grid-container m-32:b">
                <div
                    class="g-12"
                    [innerHTML]="formConfig().note"
                ></div>
            </div>
        }
        <!-- #endregion -->

        <!-- #region add object button -->
        @if (formValue()?.length < formConfig().max) {
            <div class="grid-container -spread-content -center-v m-48:v">
                <h4 class="g-12 md:g-6 strong">Weitere {{ formConfig().objectDescriptionPlural }} versichern?</h4>
                <div class="g-auto m-12:t md:m-0:t bg:grey-5">
                    <button
                        type="button"
                        class="button -ghost -add -dark fs:xs"
                        (click)="addObject()"
                    >
                        {{ formConfig().addButtonLabel }}
                    </button>
                </div>
            </div>
        }
        <!-- #endregion -->

        <!-- #region price display -->
        <app-required-info></app-required-info>
        <app-inline-price-display
            [price]="price()"
            [settlementPeriod]="settlementPeriod()"
            [taxInfo]="taxInfo()"
        />
        <!-- #endregion -->

        <!-- #region controls -->
        <app-navigation-buttons
            [nextDisabled]="form.invalid"
            [showBack]="isFirstStep"
            (prev)="btnPrev()"
            (next)="submit()"
            nextTooltip="Bitte fülle alle mit * gekennzeichneten Felder aus."
        ></app-navigation-buttons>
        <!-- #endregion -->
    </form>
}
